export enum EMerchFlag {
	obsoleteStocksRemoved = "obsoleteStocksRemoved"
}
